export const executeScroll = (props, myRef) => {
  if (props.scrollPosition !== 0) {
    myRef.current.scrollTo(0, props.scrollPosition);
  }
};
